<template>
  <div class="points-extract-page mt-4">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="Saldo atual"></app-page-header>
    <div class="current-points">
      <span>MEUS PONTOS</span>
      <span class="points">{{ points }}</span>
    </div>

    <app-page-header title="Extrato de Pontos"></app-page-header>

    <div class="container">
      <div class="listing">
        <div class="row search-fields">
          <b-field class="col-md-6 col-xm-12" label="Tipo">
            <b-select
              @input="load"
              placeholder="Selecionar"
              v-model="filters.type"
            >
              <option :value="undefined">Todos</option>
              <option
                v-for="(type, index) in types"
                :key="index"
                :value="index"
                >{{ type }}</option
              >
            </b-select>
          </b-field>

          <b-field class="col-md-6 col-xm-12" label="Período">
            <b-datepicker
              @input="load"
              v-model="datesFilter"
              :date-formatter="bDateRangeFormatter"
              placeholder="Filtrar"
              trap-focus
              range
            >
              <button
                @click="
                  datesFilter = null;
                  load();
                "
                v-app-button.icon-left.clear
              >
                <b-icon size="is-small" icon="close"></b-icon>Limpar
              </button>
            </b-datepicker>
          </b-field>
        </div>

        <b-table
          :data="data"
          :loading="isLoadingTable"
          paginated
          backend-pagination
          :total="total"
          :per-page="perPage"
          @page-change="onPageChange"
          aria-next-label="Próxima Página"
          aria-previous-label="Página Anterior"
          aria-page-label="Página"
          aria-current-label="Página Atual"
        >
          <template slot-scope="props">
            <b-table-column field="created_at" label="Data" numeric>
              {{ props.row.created_at | date('LL') }}
            </b-table-column>
            <b-table-column
              field="from"
              label="Pontos"
              class="points"
              :class="{ credit: props.row.points > 0 }"
            >
              {{ props.row.points }}
            </b-table-column>
            <b-table-column field="type" label="Tipo">
              {{ props.row.type }}
            </b-table-column>
          </template>
          <template slot="empty">
            <section>
              <h1 id="no-results">Sem resultados.</h1>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import PointTransactionService from '@/services/point-transaction.service';
import BuefyMixin from '@/mixins/BuefyMixin';

export default {
  name: 'points-extract-page',
  mixins: [BuefyMixin],
  data: () => {
    return {
      isLoading: true,
      isLoadingTable: false,
      filters: {},
      datesFilter: null,
      types: [],
      data: [],
      total: 0,
      perPage: 10,
      page: 1,
    };
  },
  computed: {
    points() {
      return this.$store.getters.userPoints;
    },
    requestFilters() {
      const [start_date, end_date] = this.datesFilter || [];

      return { ...this.filters, start_date, end_date };
    },
  },
  methods: {
    loadTypes() {
      PointTransactionService.getTypes()
        .then(({ data: types }) => (this.types = types))
        .finally(() => setTimeout(() => (this.isLoading = false), 500));
    },
    load() {
      this.isLoadingTable = true;

      PointTransactionService.get({
        page: this.page,
        perPage: this.perPage,
        ...this.requestFilters,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .finally(() => (this.isLoadingTable = false));
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  beforeMount() {
    this.loadTypes();
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.points-extract-page {
  position: relative;

  .current-points {
    border: 2px solid var(--color-secondary);
    border-radius: 8px;
    max-width: 20rem;
    margin: auto;
    padding: 1em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2em;

    span {
      font-size: 1em;
      font-weight: bold;
    }
    .points {
      font-size: 2.5em;
      color: var(--color-primary);
    }
  }

  .search-fields {
    background: var(--color-light-grey);
    margin-top: 4em;
    padding: 1em 2em;
    border-radius: 1em;
  }

  #no-results {
    margin-top: 2em;
  }

  h1 {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
  }
}

td.points {
  color: var(--color-danger);

  &.credit {
    color: var(--color-success);
    font-size: 1.2rem;
  }
}

@media(max-width: 992px) {
  .points-extract-page {
    .search-fields {
      margin: 0;
      padding: 1em;
      margin-bottom: 1em;
    }
  }
}
</style>
